var c = Object.defineProperty, f = Object.defineProperties;
var n = Object.getOwnPropertyDescriptors;
var r = Object.getOwnPropertySymbols;
var p = Object.prototype.hasOwnProperty, d = Object.prototype.propertyIsEnumerable;
var t = (e, a, o) => a in e ? c(e, a, { enumerable: !0, configurable: !0, writable: !0, value: o }) : e[a] = o, m = (e, a) => {
  for (var o in a || (a = {}))
    p.call(a, o) && t(e, o, a[o]);
  if (r)
    for (var o of r(a))
      d.call(a, o) && t(e, o, a[o]);
  return e;
}, i = (e, a) => f(e, n(a));
import s, { forwardRef as g } from "react";
import l from "../lib/IconBase.mjs";
import w from "../defs/MagicWand.mjs";
const M = g((e, a) => /* @__PURE__ */ s.createElement(l, i(m({ ref: a }, e), { weights: w })));
M.displayName = "MagicWand";
export {
  M as MagicWand
};
